var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { AvatarGroup, CellItem, Menu, Radio, Stack, Typography, } from "@vividtheory/minerva-lab";
import React, { useState } from "react";
import { DatalabIcon, DatascapeIcon, UnfoldMoreOutline, marketplaceLogoPng, } from "../icons";
import { AvatarChip } from "./AvatarChip";
import { chipClasses } from "./Chip";
import { CompanyAvatar } from "./CompanyAvatar";
import { IconAvatar } from "./IconAvatar";
import { ThumbnailAvatar } from "./ThumbnailAvatar";
/**
 * Default link component that renders an anchor tag
 */
const DefaultLink = (_a) => {
    var { href, target, style, children } = _a, props = __rest(_a, ["href", "target", "style", "children"]);
    return (React.createElement("a", Object.assign({ href: href, target: target, style: Object.assign({ textDecoration: "none", color: "inherit" }, style) }, props), children));
};
/**
 * PortalMenu is a dropdown menu that allows users to navigate between BigGeo products
 */
export function PortalMenu({ user, currentPortal, LinkComponent = DefaultLink, domain = ".biggeo.com", }) {
    var _a, _b;
    const portalUrls = {
        datalab: `https://datalab${domain}/`,
        datascape: `https://datascape${domain}/`,
        marketplace: `https://marketplace${domain}/`,
    };
    const [open, setOpen] = useState(false);
    const getPortalIcon = (portal) => {
        switch (portal) {
            case "datalab":
                return React.createElement(DatalabIcon, null);
            case "datascape":
                return React.createElement(DatascapeIcon, null);
            case "marketplace":
                return React.createElement(ThumbnailAvatar, { src: marketplaceLogoPng, size: "xxs" });
        }
    };
    const getPortalLabel = (portal) => {
        switch (portal) {
            case "datalab":
                return "Datalab";
            case "datascape":
                return "Datascape";
            case "marketplace":
                return "Marketplace";
        }
    };
    const getPortalDescription = (portal) => {
        switch (portal) {
            case "datalab":
                return "Data Management";
            case "datascape":
                return "Data Usage";
            case "marketplace":
                return "Data Marketplace";
        }
    };
    return (React.createElement(Menu, { open: open, onOpenChange: (open) => setOpen(open), placement: "bottom-start", sx: {
            padding: 0,
            maxWidth: 55,
            width: "100%",
            gap: 0,
            scrollbarGutter: "auto",
        }, content: React.createElement(React.Fragment, null,
            React.createElement(Typography, { variant: "body3", fontWeight: "semibold", textColor: "disabled.onContainer", sx: {
                    padding: 2,
                } }, "Switch product portal"),
            React.createElement(Stack, { gap: 1, sx: { padding: 2 } }, [
                currentPortal,
                ...[
                    "datascape",
                    "datalab",
                    "marketplace",
                ].filter((p) => p !== currentPortal),
            ].map((portal) => (React.createElement(LinkComponent, { key: portal, href: portalUrls[portal] || "#", target: "_blank", tabIndex: -1, style: {
                    textDecoration: "none",
                    color: "inherit",
                } },
                React.createElement(CellItem, { startNode: portal === "marketplace" ? (React.createElement(ThumbnailAvatar, { src: marketplaceLogoPng, size: "xxs" })) : (React.createElement(IconAvatar, { size: "xxs", sx: {
                            border: 1,
                            borderColor: (theme) => theme.palette.background
                                .main,
                        } }, portal === "datascape" ? (React.createElement(DatascapeIcon, null)) : (React.createElement(DatalabIcon, null)))), title: getPortalLabel(portal), subtitle: getPortalDescription(portal), slotProps: {
                        subtitle: {
                            textColor: "disabled.onContainer",
                            variant: "body4",
                        },
                    }, sx: {
                        padding: 2,
                    }, endNode: React.createElement(Radio, { checked: currentPortal === portal, as: "div" }) })))))) },
        React.createElement(AvatarChip, { density: "dense", variant: "outlined", focused: open, startNode: React.createElement(AvatarGroup, { size: "xxs" },
                React.createElement(CompanyAvatar, { src: ((_a = user.organization) === null || _a === void 0 ? void 0 : _a.img) || "", alt: (_b = user.organization) === null || _b === void 0 ? void 0 : _b.name }),
                React.createElement(IconAvatar, { sx: {
                        border: 1,
                        borderColor: (theme) => theme.palette.background.main,
                    } }, getPortalIcon(currentPortal))), endNode: React.createElement(UnfoldMoreOutline, { size: "sm", sx: {
                    transform: open ? "scale(1.25)" : "none",
                    transition: "transform 0.05s ease-in-out",
                } }), slotProps: {
                label: {
                    align: "left",
                    sx: {
                        flexGrow: 1,
                    },
                },
            }, sx: {
                width: "100%",
                [`&.${chipClasses.outlined}`]: {
                    boxShadow: (theme) => `inset 0 0 0 1px ${theme.palette.stroke[100]}`,
                },
            } }, getPortalLabel(currentPortal))));
}
//# sourceMappingURL=PortalMenu.js.map